import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../../config/index';
import { Translate } from '../../../../../config/Translate';
import {Link, withRouter} from 'react-router-dom';
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../../components/elements/LoadingButton";
import Typography from "@material-ui/core/Typography/Typography";
import Button from "@material-ui/core/Button/Button";

class ChooseMobile extends React.Component {
    constructor(props){
        super(props);
        this.state={
            fields: {
                mobile:0,
            },
            errors:{},
            SubmitLoading:false,
        };
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({fields});
    }
    async handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //mobile
        if(!validator.isNumeric(fields.mobile) || fields.mobile.length !== 11){
            formIsValid = false;
            errors['mobile'] = Translate.wrongMobile;
        }
        await this.setState({errors},() =>{
            if(!formIsValid){
                this.setState({
                    SubmitLoading:false
                })
            }
            return callback(formIsValid)
        });
    }
    async handleRequest(){
        const {mobile} = this.state.fields;
        let data = new FormData();
        data.append('mobile', mobile);
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.post(`${defaultVariabls.url}/forgetPass/setMobile`, data, config)
            .then(response =>{
                console.log(response.data)
                this.setState({
                    SubmitLoading:false
                })
                this.props.setUser(response.data);

                this.props.setNextLevel();
            })
            .catch(error =>{
                console.log(error.response);
                this.props.enqueueSnackbar(Translate.invalidMobileNumber, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                })
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    render() {
        const {errors,SubmitLoading} = this.state;
        return (
            <form style={{width:'100%'}} noValidate onSubmit={this.handleSubmit.bind(this)}>
                <Grid item xs={12}>
                    <TextField
                        required
                        fullWidth
                        id="mobile"
                        label={Translate.mobile}
                        name="mobile"
                        margin="normal"
                        variant="outlined"
                        onChange={this.handleChange.bind(this)}
                        autoFocus
                        error = {!!errors['mobile']}
                        helperText={errors['mobile']}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography align="left" color="textSecondary">{Translate.addYourNumberFirst}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        style={{width:"100%"}}
                        onClick = {this.handleSubmit.bind(this)}
                        loading = {SubmitLoading}
                    >
                        {Translate.confirm}
                    </LoadingButton>
                </Grid>
                {
                    this.props.hasBack &&
                    <Grid item xs={12}>
                        <Button style={{width:'100%'}} component={Link} to="/login" color="primary" variant="outlined">
                            <strong>
                                {Translate.loginWithUserPass}
                            </strong>
                        </Button>
                    </Grid>
                }

            </form>

        );

    }
}

export default withSnackbar(withRouter(withStyles(Styles)(ChooseMobile)));